function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCategoryBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.63281L10 16.6328",
    stroke: "#CCD5D3",
    style: {
      stroke: "#CCD5D3",
      stroke: "color(display-p3 0.8000 0.8353 0.8275)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.6328L4 10.6328",
    stroke: "#CCD5D3",
    style: {
      stroke: "#CCD5D3",
      stroke: "color(display-p3 0.8000 0.8353 0.8275)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCategoryBtn);
export default __webpack_public_path__ + "static/media/addCategoryBtn.31208430126f612628fa5849756dfb8e.svg";
export { ForwardRef as ReactComponent };